import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Contact = () => {
  const [heroRef, heroInView] = useInView({ threshold: 0.3, triggerOnce: true });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your message! We\'ll get back to you soon.');
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <motion.div
      className="service-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      <section className="service-hero parallax-container" ref={heroRef}>
        <div className="parallax-bg"></div>
        <div className="container">
          <motion.div
            className="hero-content text-center"
            initial={{ opacity: 0, y: 50 }}
            animate={heroInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1>Contact Us</h1>
            <p className="hero-description">
              Ready to transform your business? Get in touch with our experts to discuss
              your project and discover how CloudRaize can help you achieve your goals.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid-2">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="contact-info">
                <h2>Get In Touch</h2>
                <p>Email: contact@cloudraize.com</p>
                <p>Phone: +91 8106109054</p>
                <p>Address: MIG-59, Om sari sai nilayam, 4th floor, Flot no : 4S, Dharmareddy colony, Kphp colony, Hyderabad, Telangana,-500085</p>
              </div>
            </motion.div>

            <motion.form
              className="contact-form card"
              onSubmit={handleSubmit}
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="company"
                placeholder="Company Name"
                value={formData.company}
                onChange={handleChange}
              />
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="">Select a Service</option>
                <option value="devops">DevOps</option>
                <option value="cloud">Cloud Services</option>
                <option value="data-science">Data Science</option>
                <option value="data-engineering">Data Engineering</option>
                <option value="generative-ai">Generative AI</option>
                <option value="app-development">App Development</option>
              </select>
              <textarea
                name="message"
                placeholder="Tell us about your project"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <button type="submit" className="btn">Send Message</button>
            </motion.form>
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Contact;
